// Module
var code = "<div class=\"text-wrapper\" uib-tooltip-html=\"ctrl.sTooltip\"> <div class=\"truncate\" ng-transclude> </div> </div> ";
// Exports
module.exports = code;